import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { GET_QUOTES } from './quotes.query';
import { GET_QUOTE_PACKAGE_PAGE } from './quote-package-page.query';
import { GET_SUBMISSION } from './submission.query';
import { BindQuoteMutation, BindQuoteMutationVariables } from '../gql/graphql';
import { GET_SUBMISSIONS } from './submissions.query';
import { GET_QUOTES_PAGE } from './quotes-page.query';

export const BIND_QUOTE = graphql(`
  mutation bindQuote(
    $submissionDetails: SubmissionInput!
    $boundQuoteUuid: String!
    $boundQuoteStatus: QuoteStatus!
    $coverages: [HasCoverageInput!]!
    $endorsements: [HasEndorsementInput!]!
  ) {
    bindQuote(
      submissionDetails: $submissionDetails
      quoteUuid: $boundQuoteUuid
      status: $boundQuoteStatus
      coverages: $coverages
      endorsements: $endorsements
    ) {
      uuid
      status
    }
  }
`);

export function useBindQuoteMutation(
  options: MutationHookOptions<
    BindQuoteMutation,
    BindQuoteMutationVariables
  > = {}
) {
  const [bindQuote, { loading, error, reset }] = useMutation(BIND_QUOTE, {
    refetchQueries: [
      GET_QUOTES,
      GET_QUOTE_PACKAGE_PAGE,
      GET_SUBMISSION,
      GET_SUBMISSIONS,
      GET_QUOTES_PAGE,
    ],
    awaitRefetchQueries: true,
    ...options,
  });

  return {
    bindQuote,
    loading,
    error,
    reset,
  };
}
